export default "__VITE_ASSET__Bt33DgWn__"